import React, { useEffect } from 'react';
import AnalyticsPage from './analytics/AnalyticsPage';
import './users/users.css';
import './users/brand.css';
import './analytics/analytics.css';
export default function Analytics() {
  useEffect(() => { document.body.classList.add('users-brand'); return () => document.body.classList.remove('users-brand'); }, []);
  return <AnalyticsPage />;
}
